// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".5c2c6b3dba3f9a87d45a67c3151e283cfa998610.chunk.js";
};